import { useQuery } from '@tanstack/react-query';
import { apiService } from '@/lib/api';
export function useMainTournaments() {
    return useQuery({
        queryKey: ['mainTournaments'],
        queryFn: () => apiService.getMainTournaments(),
        staleTime: 1000 * 60 * 10, // 10 minutes
        refetchOnWindowFocus: false,
        retry: 2,
    });
}
export function useScbTournaments() {
    return useQuery({
        queryKey: ['scbTournaments'],
        queryFn: () => apiService.getScbTournaments(),
        staleTime: 1000 * 60 * 10, // 10 minutes
        refetchOnWindowFocus: false,
        retry: 2,
    });
}
export function useTournamentResults(tournamentId) {
    return useQuery({
        queryKey: ['tournamentResults', tournamentId],
        queryFn: () => tournamentId ? apiService.getTournamentResults(tournamentId) : null,
        enabled: !!tournamentId,
        staleTime: 1000 * 60 * 10, // 10 minutes
        refetchOnWindowFocus: false,
        retry: 2,
    });
}
export function useHistoricalTournaments() {
    return useQuery({
        queryKey: ['historicalTournaments'],
        queryFn: () => apiService.getHistoricalTournaments(),
        staleTime: 1000 * 60 * 10, // 10 minutes
        refetchOnWindowFocus: false,
        retry: 2,
    });
}
export function useHistoricalTournamentByYear(year) {
    return useQuery({
        queryKey: ['historicalTournament', year],
        queryFn: () => year ? apiService.getHistoricalTournamentByYear(year) : null,
        enabled: !!year,
        staleTime: 1000 * 60 * 10, // 10 minutes
        refetchOnWindowFocus: false,
        retry: 2,
    });
}
// Hook to get both tournament lists
export function useAllTournaments() {
    const mainQuery = useMainTournaments();
    const scbQuery = useScbTournaments();
    const historicalQuery = useHistoricalTournaments();
    return {
        mainTournaments: Array.isArray(mainQuery.data) ? mainQuery.data : [],
        scbTournaments: Array.isArray(scbQuery.data) ? scbQuery.data : [],
        historicalTournaments: Array.isArray(historicalQuery.data) ? historicalQuery.data : [],
        isLoading: mainQuery.isLoading || scbQuery.isLoading || historicalQuery.isLoading,
        hasError: mainQuery.error || scbQuery.error || historicalQuery.error,
        error: mainQuery.error || scbQuery.error || historicalQuery.error
    };
}
